import React from 'react';
import { ThemeProvider } from '@oneaudi/unified-web-common';

interface SafeThemeProviderProps {
  children: React.ReactNode;
}

export const SafeThemeProvider: React.FC<SafeThemeProviderProps> = ({ children }) => {
  // Check if we're in browser environment
  const isBrowser = typeof window !== 'undefined';

  if (!isBrowser) {
    // During SSR, just return children without ThemeProvider
    return <>{children}</>;
  }

  // In browser, use ThemeProvider normally
  return <ThemeProvider>{children}</ThemeProvider>;
};
